import React from 'react'
import type {TPAComponentProps} from 'wix-ui-tpa/dist/src/types'
import {Divider as WixDivider} from 'wix-ui-tpa/Divider'
import {classes} from './divider.st.css'

export const DateDivider: React.FC<TPAComponentProps> = props => <WixDivider {...props} className={classes.date} />

export const ItemDivider: React.FC<TPAComponentProps> = props => <WixDivider {...props} className={classes.item} />
